<template>
  <div class="pa-4">
    <v-textarea
      v-model="testText"
      label="Text to moderate"
      rows="4"
      variant="solo"
    />
    <v-select
      v-model="testAiType"
      :items="aiTypes"
      label="AI"
      class="mt-2"
    />
    <v-btn
      color="primary"
      :disabled="!testText || loading"
      @click="testModeration"
    >
      Test moderation
    </v-btn>
    <div
      v-if="loading"
      class="mt-4"
    >
      Testing...
    </div>
    <div
      v-else-if="result"
      class="mt-4"
    >
      <v-alert
        :type="result.flagged ? 'error' : 'success'"
      >
        {{ result.flagged ? 'Flagged' : 'Not flagged' }}
      </v-alert>
      <div
        v-if="result.flaggedCategories.length > 0"
        class="mt-2"
      >
        <strong>Flagged categories:</strong>
        <v-chip
          v-for="cat in result.flaggedCategories"
          :key="cat"
          class="ma-1"
          color="error"
        >
          {{ cat }}
        </v-chip>
      </div>
      <div class="mt-4">
        <strong>Raw AI response:</strong>
        <pre
          class="mt-1 pa-2"
          style="background: #1e1e1e; border-radius: 4px; white-space: pre-wrap;"
        >{{ result.rawResponse || 'N/A' }}</pre>
      </div>
    </div>
    <div
      v-else-if="error"
      class="mt-4"
    >
      <v-alert type="error">
        {{ error }}
      </v-alert>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { AiType, parseAiType } from '../../../../common/src/Types'

interface ModerationResult {
  flagged: boolean
  flaggedCategories: string[]
  rawResponse?: string
}

const aiTypes = Object.values(AiType)
const testText = ref<string>('')
const testAiType = ref<AiType>(parseAiType(undefined))
const loading = ref<boolean>(false)
const result = ref<ModerationResult | null>(null)
const error = ref<string>('')

const testModeration = async () => {
  loading.value = true
  result.value = null
  error.value = ''
  try {
    const res = await fetch('/api/_test_moderation', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ testText: testText.value, testAiType: testAiType.value }),
    })
    if (res.status === 200) {
      result.value = await res.json()
    } else {
      error.value = 'Failed to test moderation'
    }
  } catch (e: any) {
    error.value = e.message || 'Unknown error'
  } finally {
    loading.value = false
  }
}
</script>
